import React from 'react';
import ChevronDownSmall from 'wix-ui-icons-common/ChevronDownSmall';
import { t } from '../../utils/i18n';
import { DH } from '../../utils/dataHooks';
import { classes } from './styles.st.css';

export interface Props {
  onClick(): void;
}

export const MorePaymentOptionsView: React.FC<Props> = (props) => {
  return (
    <div data-hook={DH.MorePaymentOptions.Wrapper} className={classes.wrapper}>
      <span
        data-hook={DH.MorePaymentOptions.Button}
        className={classes.button}
        onClick={props.onClick}
        role="button"
        tabIndex={0}
      >
        {t('morePaymentOptions')}
        <ChevronDownSmall />
      </span>
    </div>
  );
};
